export default __webpack_public_path__ + "static/media/Icestrike.86182486.jpg";